import { createSelector } from "@ngrx/store";
import { AppState } from "src/app/store/app.reducer";

export const selectNotifications = (state: AppState) => state.notifications;

export const selectNotificationList = createSelector(
  selectNotifications,
    (state) => state.notifications
);
export const selectToastNotification = createSelector(
  selectNotifications,
    (state) => state.toastNotification
);
export const selectTopbarTitle = createSelector(
  selectNotifications,
  (state) => state.topbarTitle
);
export const selectShowProgressSpinner = createSelector(
  selectNotifications,
  (state) => state.showProgressSpinner
);
